import { assoc, compose, filter, keys, map } from 'ramda'
import { extractIdFromIri } from '@/utils/iri'
import yodaFormatter from '../yodaFormatter'

/**
 * Load additional data for the basket to function.
 */
const loadAdditionalBasketData = ({ fetchPath, offerLineIriUnitQuantityMapFactory }) => async (basket) => {
  let offerData = await Promise.all(basket.offers.map((offer) => (
    fetchPath.run({
      path: `/yoda/api/offers/${offer.id}`,
      jsonPath: ['content', 'data'],
    }).then(({ id: iri, attributes, ...offerData }) => ({
      ...offerData,
      ...attributes,
      iri,
      totals: offer.totals,
    }))
  )))

  const offerLineIriUnitQuantityMap = offerLineIriUnitQuantityMapFactory(basket.basketLines)

  /*
   * const ids = compose(extractIdFromIri, keys)(offerLineIriUnitQuantityMap)
   * const idFilters = compose(join('&'), idQueryParametersFactory, keys)(offerLineIriUnitQuantityMap)
   */
  const offerLines = await fetchPath.run({
    path: '/yoda/api/offer-lines',
    parameters: { id: compose(map(extractIdFromIri), keys)(offerLineIriUnitQuantityMap) },
    jsonPath: ['content', 'data'],
  }).then(
    compose(
      map(
        compose(
          (offerLine) => assoc('unitQuantity', offerLineIriUnitQuantityMap[offerLine.iri], offerLine),
          yodaFormatter,
        ),
      ),
      filter(({ id }) => Object.prototype.hasOwnProperty.call(offerLineIriUnitQuantityMap, id)),
    ),
  ).catch(() => ([]))

  offerData = offerData.map((offer) => ({
    ...offer,
    offerLines: offerLines.filter(({ offer: offerIRI }) => offerIRI === offer.iri),
  }))

  return {
    ...basket,
    offers: offerData,
    additionalDataLoaded: true,
  }
}

export default loadAdditionalBasketData
